'use strict';

export default function($stateProvider) {
  'ngInject';

  $stateProvider
    .state('tvs_paddock_benchmark', {
      url: '/tvs_paddock_benchmark',
      template: '<tvspaddockbenchmarktab></tvspaddockbenchmarktab>',
      authenticate: 'admin'
    });
}
